import { useMemo, useState } from "react";
import DataTable from "../../../../../components/DataTable";
import useFetchSurveys from "./useFetchSurveys";
import { Tooltip } from "@material-ui/core";
import * as dateFNS from "date-fns";
import { BiEdit, BiLinkExternal, BiTrash } from "react-icons/bi";
import {
  NewSurveyLink,
  RowActionButton,
  RowActionLink,
  RowActionsContainer,
  TableTitle,
  TableToolbarContainer,
} from "./styles";
import { SURVEY_STATUS } from "../../constants";
import SurveyRowActions from "./SurveyRowActions";
import { IoMdLink } from "react-icons/io";

export default function SurveysTable() {
  const [selectedFilters, setSelectedFilters] = useState({});
  const { 
    data, 
    page, 
    rowsPerPage,
    loading, 
    changePage,
    changeRowsPerPage,
    refetch 
  } = useFetchSurveys({ 
    search: selectedFilters?.search, 
    statusID: selectedFilters?.status 
  });

  /**@type {import("../../../../../components/DataTable/interfaces").TableColumn[]} */
  const columns = [
    { key: "id", name: "ID", align: 'center', width: '20px' },
    { key: "name", name: "Nome" },
    { key: "url", name: "URL", maxWidth: '400px', isSingleLine: true },
    { key: "created_at", name: "Criado em", align: 'center', width: '120px' },
    {
      key: "status",
      name: "Status",
      align: "center",
      renderCustomRow: (row) => (
        <Tooltip title={row?.status?.tooltip}>
          <span>{row?.status?.name}</span>
        </Tooltip>
      ),
      width: '120px'
    },
    { key: "expires_in", name: "Expira em", align: 'center', width: '180px' },
    { key: "actions", name: "Ações", align: 'center', width: '96px' },
  ];

  const rows = useMemo(() => {
    return data?.data?.map((item) => {
      return {
        id: item.id,
        name: item.name,
        url: (
          <a href={`https://voitto.com.br/pesquisa/${item.url}`} target="_blank" style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
            <span>{item.url}</span>
            <BiLinkExternal />
          </a>
        ),
        created_at: dateFNS.format(new Date(item.created_at), "dd/MM/yyyy"),
        status: item.status,
        expires_in: item?.expires_in ? dateFNS.format(new Date(item.expires_in), 'dd/MM/yyyy') : "Sem data limite",
        actions: <SurveyRowActions surveyID={item.id} slug={item.url} onDelete={refetch} />
      };
    });
  }, [data, refetch]);

  /**@type {import("../../../../../components/DataTable/interfaces").TableFilter[]} */
  const filters = [
    {
      key: "search",
      name: "Nome da pesquisa",
      component: { type: "text", placeholder: "Busque pelo nome da pesquisa" },
    },
    {
      key: "status",
      name: "Status",
      component: {
        type: "select",
        options: [
          { key: "all", name: "Todos os status", description: "Todos os status" },
          { key: SURVEY_STATUS.INACTIVE, name: "Inativo", description: "Pesquisas inativas" },
          { key: SURVEY_STATUS.ACTIVE, name: "Ativo", description: "Pesquisas ativas" },
          { key: SURVEY_STATUS.INTERNAL, name: "Interno", description: "Pesquisas internas" },
        ],
      },
    },
  ];

  return (
    <DataTable
      hasStickHeader
      showPagination
      showFilters
      CustomToolbarElement={
        <TableToolbarContainer>
          <TableTitle>Pesquisas</TableTitle>
          <NewSurveyLink href="/admin/pesquisa/novo">
            Nova Pesquisa
          </NewSurveyLink>
        </TableToolbarContainer>
      }
      columns={columns}
      rows={rows}
      filters={filters}
      isLoading={loading}
      page={page}
      rowsPerPage={rowsPerPage}
      totalRecords={data?.paging?.total}
      selectedFilters={selectedFilters}
      onPageChange={changePage}
      onRowsPerChange={changeRowsPerPage}
      onSubmitFilters={(filters) => setSelectedFilters(filters)}
      onResetFilters={() => setSelectedFilters({})}
    />
  );
}